import RestClientService from "@/core/services/restClient.service";
import {
  ChangePasswordDto,
  ForgotPasswordDto,
  LoginDto,
  SignupDto,
  ResetPasswordDto,
} from "@/modules/Auth/dtos/auth.dto";
import { ChangeNumberDto } from "@/modules/Profile/dtos/auth.dto";
import { API_PATH } from "@/core/constants/apiPath";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { LoginResponseModel } from "@/core/models/loginResponse.model";
import { LoginResponse } from "../types";
import type { VerifyLoginAuthenticatorDto } from "@/modules/Auth/dtos/auth.dto";

class AuthService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public login(body: LoginDto): Promise<ICoreResponse<LoginResponse>> {
    return this.restClient.post(API_PATH.login, body);
  }

  public signup(body: SignupDto): Promise<ICoreResponse<LoginResponseModel>> {
    const { recaptcha_token, ...payload } = body;

    return this.restClient.post(API_PATH.signup, payload, {
      headers: {
        "Recaptcha-Token": recaptcha_token,
      },
    });
  }

  public forgotPassword(body: ForgotPasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.forgotPassword, body);
  }

  public resetPassword(body: ResetPasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.changePassword, body);
  }

  public changePassword(body: ChangePasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.resetPassword, body);
  }
  public changeNumber(body: ChangeNumberDto): Promise<ICoreResponse> {
    return this.restClient.patch(API_PATH.changePhoneNumber, body);
  }

  public verifyAuthenticator(
    body: VerifyLoginAuthenticatorDto,
  ): Promise<ICoreResponse<LoginResponse>> {
    return this.restClient.post(API_PATH.verifyAuthenticator, body);
  }

  public disableMfaByToken(token: string): Promise<ICoreResponse> {
    return this.restClient.get(API_PATH.disableMfaByToken, { token });
  }
}

export default AuthService;
